import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { forkJoin, Subject } from 'rxjs';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var WorkspaceService = /** @class */ (function () {
    // documentClick: Subject<any> = new Subject<any>();
    // documentClickChanged$ = this.documentClick.asObservable();
    function WorkspaceService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.defaultId = '00000000-0000-0000-0000-000000000000';
        this.parentId = "";
        this.currentParentId = new Subject();
        this.currentParentIdChanged$ = this.currentParentId.asObservable();
        this.serviceUrl = this.env.servicePath;
    }
    WorkspaceService.prototype.setParentId = function (id) {
        // if (this.parentId != id){ //avoid registering duplicate id
        this.parentId = id;
        this.currentParentId.next(id);
        // }
    };
    // setDocumentClick(event:any){
    //   this.documentClick.next(event);
    // }
    WorkspaceService.prototype.getEPICPage = function (pageName, isMobile) {
        var path = this.serviceUrl + "GetEPICPage/" + pageName + "?isMobile=" + isMobile;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getEPICGroup = function (pageId, groupId) {
        var path = this.serviceUrl + "GetEPICGroup/" + pageId + "/" + groupId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getEPICGroupAll = function (pageId, groupIds) {
        var getObs = [];
        for (var _i = 0, groupIds_1 = groupIds; _i < groupIds_1.length; _i++) {
            var groupId = groupIds_1[_i];
            var path = this.serviceUrl + "GetEPICGroup/" + pageId + "/" + groupId;
            var httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
            };
            getObs.push(this.http.get("" + path, httpOptions));
        }
        return forkJoin(getObs);
    };
    WorkspaceService.prototype.getRelatedEPICs = function (conversationId, messageId, groupId, groupOrder) {
        var path = this.serviceUrl + "GetRelatedEPICs/" + conversationId + "/" + messageId + "/" + groupId + "/" + groupOrder;
        ;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.searchEPICs = function (searchTerm) {
        var path = this.serviceUrl + "SearchEpicByTag/" + searchTerm;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getSearchResult = function (id) {
        var path = this.serviceUrl + "GetSearchResult/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getEPICContent = function (groupId, contentId, body) {
        var path = this.serviceUrl + "GetEPICContent/" + groupId + "/" + contentId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, body, httpOptions);
    };
    WorkspaceService.prototype.getParentEPICId = function (id) {
        var path = this.serviceUrl + "GetParentEPICId/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getAllParentsEPICId = function (id) {
        var path = this.serviceUrl + "GetAllParentsEPICId/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getAppVersion = function () {
        var path = this.serviceUrl + "GetAppVersion";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getNotificationPrompt = function () {
        var path = this.serviceUrl + "GetNotificationPrompt";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getKpiCard = function (id) {
        var path = this.serviceUrl + "GetKpiCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getWebContentCard = function (id) {
        var path = this.serviceUrl + "GetWebContentCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.getFAQ = function () {
        var path = this.serviceUrl + "GetFAQ";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    WorkspaceService.prototype.closeCard = function (id) {
        var path = this.serviceUrl + "CloseCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    WorkspaceService.prototype.executeGenericWorkflow = function (actionName, param) {
        var path = this.serviceUrl + "ExecuteGenericWorkflow/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    WorkspaceService.prototype.convertToDecimal = function (value, formatString) {
        var path = this.serviceUrl + "ConvertToDecimal/" + value;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, formatString, httpOptions);
    };
    WorkspaceService.ngInjectableDef = i0.defineInjectable({ factory: function WorkspaceService_Factory() { return new WorkspaceService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: WorkspaceService, providedIn: "root" });
    return WorkspaceService;
}());
export { WorkspaceService };
